"use strict";
import * as React from "react";

const Modal = ({ id, children, handleKeyPress }) => (
  <div
    id={id}
    className="modal fade"
    role="dialog"
    tabIndex="0"
    onKeyDown={e => {
      e.preventDefault();
      handleKeyPress(e);
    }}
  >
    <div className="modal-dialog">
      <div className="modal-content">
      <button type="button" className="close" data-dismiss="modal">
        &times;
      </button>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  </div>
);

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js